import { AddAISystemAction } from '../AddAISystemAction/AddAISystemAction';

export const AddAISystemBanner: React.FC = () => {
  return (
    <div className="flex w-full py-6 rounded-lg px-6 gap-4 bg-white ring-1 ring-gray-250v2 shadow-sm">
      <div className="flex flex-row gap-1 w-full justify-between items-center">
        <div className="flex flex-col gap-1">
          <h2 className="font-inter text-xl text-left font-semibold text-gray-900 leading-[32px]">
            Identify Your AI System's Risk
          </h2>
          <p className="font-inter text-sm font-normal text-gray-800">
            Add your AI system to check its category, review compliance
            obligations, and begin monitoring.
          </p>
        </div>
        <AddAISystemAction />
      </div>
    </div>
  );
};
